import ExportButton from '../../1elements/Buttons/TextButtons/ExportButton'
import StepperBase from '../StepperBase'

const StepperDataExport = ({steps, getStepContent, handleExportButton, disabled}) => {
    const finalAction = (<ExportButton onClick={handleExportButton} />)

    return (
        <StepperBase steps={steps} getStepContent={getStepContent} finalAction={finalAction} orientation={'vertical'} disabled={disabled} isImport = {false} />
    )
}

export default StepperDataExport